import React from "react";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    className="btn btn-outline-primary dropdown-toggle"
    style={{
      border: '1px solid #ced4da',
      color: '#495057',
      backgroundColor: '#fff',
      transition: 'none',
      whiteSpace: 'wrap',
      textAlign: 'left',
    }}
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </button>
));

export default CustomToggle;